import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const threeCx = defineConnector({
  identifier: "threeCx",
  name: "3CX",
  tagLine: "Business phone system",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ domain }) =>
    `https://${domain ? domain.replace(/\./g, "\\.") : ".*\\.3cx\\.[a-z]+"}/xapi/.*`,
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/connect/token`,
        method: "POST",
        headers: [
          {
            name: "Accept",
            value: "application/json",
          },
        ],
        formBody: {
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
          grant_type: "client_credentials",
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Find your 3CX domain",
      items: [
        {
          kind: "markdown",
          content:
            "Your 3CX domain is the URL you use to access your 3CX instance, e.g. `mycompany.3cx.us`.",
        },
        {
          kind: "input",
          label: "3CX domain",
          placeholder: "mycompany.3cx.us",
          required: true,
          helperText: "Enter only the domain, without `https://` or a path.",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API integration",
      items: [
        {
          kind: "markdown",
          content: ({ domain }: Record<string, string>) => {
            const consoleLink = domain
              ? `[3CX admin console](https://${domain})`
              : "your 3CX admin console";

            return `In ${consoleLink}, navigate to **Integrations** and create a new API integration. Copy the client ID and API key.`;
          },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/xapi/v1/status`,
  },
});
